import React from "react";
import "./SettingsNewPrivacyMainbox.css";

function PrivacyMainbox() {
  return <div className="settingsnewprivacymainbox"></div>;
}

export default PrivacyMainbox;
